/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetCrosshairIcon24Regular = forwardRef('TargetCrosshairIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm1.534-.75a8.252 8.252 0 0 1 7.466-7.466V7a.75.75 0 0 0 1.5 0V3.784a8.252 8.252 0 0 1 7.466 7.466H17a.75.75 0 0 0 0 1.5h3.216a8.252 8.252 0 0 1-7.466 7.466V17a.75.75 0 0 0-1.5 0v3.216a8.252 8.252 0 0 1-7.466-7.466H7a.75.75 0 0 0 0-1.5H3.784Z" })));
});
